module.exports = __webpack_public_path__ + "fonts/Poppins-Regular.4ca79fd9.woff2";